import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useSetting } from '../../../composables/setting';

export default defineComponent({
  name: 'NavigatorComponent',
  setup: () => {
    const setting = useSetting();
    const language = ref<'EN' | 'TH'>('EN');
    const size = ref<'ก+' | 'ก-'>('ก+');
    const route = useRoute();
    const sections = [
      { name: 'header.announcement', link: '/announcements' },
      { name: 'header.video', link: '/videos' },
      { name: 'header.project', link: '/project' },
      { name: 'header.province', link: '/province' },
      { name: 'header.psc', link: '/psc' },
      { name: 'header.document', link: '/documents' },
      { name: 'header.other', link: '/others' },
    ];

    const sizeClick = () => {
      setting.fontSize(size.value);
      size.value = size.value === 'ก+' ? 'ก-' : 'ก+';
    };

    const langaugeClick = () => {
      setting.language(language.value);
      language.value = language.value === 'EN' ? 'TH' : 'EN';
    };

    return {
      route,
      sections,
      size,
      language,
      sizeClick,
      langaugeClick,
    };
  }
});
